import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
import Icon from '@welldev-group/rcl-icon';
import IconButton from '@welldev-group/rcl-icon-button';
import { I18nText } from '@welldev-group/react-comp-lib';
import routes from '../../../shared/routes';
import httpClient from '../../../shared/libraries/httpClient';
import LeftPanel from './LeftPanel';
import MessageThread from './MessageThread';
import RightPanel from './RightPanel';

const Support = props => {
  const { signedInAsSuperAdmin, superAdmins } = props;
  const [searchParam, setSearchParam] = useState('');
  const [supportTickets, setSupportTickets] = useState([]);
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [affiliateId, setAffiliateId] = useState(null);
  const [assigneeId, setAssigneeId] = useState(null);
  const [statuses, setStatuses] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [leftPanelShow, setLeftPanelShow] = useState(false);
  const [rightPanelShow, setRightPanelShow] = useState(false);

  const fetchTickets = async () => {
    const { data } = await httpClient.get(
      routes.support.tickets.list({
        q: searchParam,
        affiliate_id: affiliateId,
        assigned_to_id: assigneeId,
        start_date: startDate,
        end_date: endDate,
        'statuses[]': statuses,
      }),
    );
    setSupportTickets(data.supportTickets);
  };

  useEffect(() => {
    fetchTickets();
  }, [searchParam, affiliateId, assigneeId, statuses, startDate, endDate]);

  const selectedSupportTicket = supportTickets.filter(
    supportTicket => supportTicket.id === selectedTicketId,
  );

  const supportTicketToShow =
    selectedSupportTicket.length > 0 ? selectedSupportTicket[0] : null;

  return (
    <div className="support">
      <div
        className={ClassNames('support__left-panel', {
          'support__left-panel--show': leftPanelShow,
        })}
      >
        <LeftPanel
          fetchTickets={fetchTickets}
          signedInAsSuperAdmin={signedInAsSuperAdmin}
          supportTickets={supportTickets}
          selectedTicketId={selectedTicketId}
          setSelectedTicketId={setSelectedTicketId}
          searchParam={searchParam}
          setSearchParam={setSearchParam}
          affiliateId={affiliateId}
          setAffiliateId={setAffiliateId}
          superAdmins={superAdmins}
          assigneeId={assigneeId}
          setAssigneeId={setAssigneeId}
          statuses={statuses}
          setStatuses={setStatuses}
          leftPanelShow={leftPanelShow}
          setLeftPanelShow={setLeftPanelShow}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </div>
      <div
        className={ClassNames('support__message-thread', {
          'support__message-thread--expanded': !supportTicketToShow,
        })}
      >
        <div className="support__panel-actions">
          <div className="support__panel-actions-left">
            <IconButton
              version="v2"
              icon={<Icon name="listBulleted" />}
              onClick={() => setLeftPanelShow(!leftPanelShow)}
              size="tiny"
              isIconOnly={true}
            />
            <div
              onClick={() => setLeftPanelShow(!leftPanelShow)}
              role="presentation"
            >
              <I18nText id="support.tickets" />
            </div>
          </div>
          {supportTicketToShow && (
            <div className="support__panel-actions-right">
              <IconButton
                version="v2"
                icon={<Icon name="more" />}
                onClick={() => setRightPanelShow(!rightPanelShow)}
                size="tiny"
                isIconOnly={true}
              />
            </div>
          )}
        </div>
        <MessageThread
          key={selectedTicketId}
          fetchTickets={fetchTickets}
          selectedSupportTicketId={selectedTicketId}
          ticketCreatedBy={supportTicketToShow && supportTicketToShow.createdBy}
          signedInAsSuperAdmin={signedInAsSuperAdmin}
        />
      </div>
      {supportTicketToShow && signedInAsSuperAdmin && (
        <div
          className={ClassNames('support__right-panel', {
            'support__right-panel--show': rightPanelShow,
          })}
        >
          <RightPanel
            supportTicket={supportTicketToShow}
            fetchTickets={fetchTickets}
            rightPanelShow={rightPanelShow}
            setRightPanelShow={setRightPanelShow}
          />
        </div>
      )}
    </div>
  );
};

Support.propTypes = {
  signedInAsSuperAdmin: PropTypes.bool.isRequired,
  superAdmins: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  ).isRequired,
};

export default Support;
